export default __webpack_public_path__ + "static/topShadow-c3efa2282f2fc733a49855b7b6c8eef9.png";